/**
 * Mobile sticky checkout bar for bundle LPs (lose / gain + Hebrew handles).
 * Shows when the hero CTA scrolls out of view; reuses simple-checkout-btn behavior.
 */
(function () {
  'use strict';

  function isBundleLpPage() {
    return (
      document.body.classList.contains('template-page-lose-weight-simple') ||
      document.body.classList.contains('template-page-מארז-ירידה-במשקל') ||
      document.body.classList.contains('template-page-gain-mass-simple') ||
      document.body.classList.contains('template-page-מארז-עלייה-במסה')
    );
  }

  function findHeroCheckoutButton() {
    return (
      document.querySelector('[id*="enhanced_rich_text_hero"] a.simple-checkout-btn') ||
      document.querySelector('.enhanced-rich-text a.simple-checkout-btn')
    );
  }

  function init() {
    if (!isBundleLpPage()) return;
    if (document.querySelector('.lose-weight-sticky-cta-bar')) return;

    const mq = window.matchMedia('(max-width: 768px)');
    const heroBtn = findHeroCheckoutButton();
    if (!heroBtn) return;

    const bar = document.createElement('div');
    bar.className = 'lose-weight-sticky-cta-bar';
    bar.setAttribute('aria-hidden', 'true');

    const link = document.createElement('a');
    link.href = heroBtn.getAttribute('href') || '#';
    link.className = heroBtn.className + ' lose-weight-sticky-cta-bar__btn';
    link.textContent = (heroBtn.textContent || '').trim() || 'הזמינו עכשיו';
    if (heroBtn.dataset.variantId) {
      link.dataset.variantId = heroBtn.dataset.variantId;
    }

    bar.appendChild(link);
    document.body.appendChild(bar);

    function setVisible(on) {
      if (!mq.matches) {
        bar.classList.remove('is-visible');
        document.body.classList.remove('lose-weight-sticky-cta-active');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('lose-weight-sticky-cta-active', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    const io = new IntersectionObserver(
      function (entries) {
        const e = entries[0];
        if (!e) return;
        setVisible(!e.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    io.observe(heroBtn);

    mq.addEventListener('change', function () {
      if (!mq.matches) {
        setVisible(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
